import { AppSettings } from "../../app-settings";
import { prop } from "../../decorators/property";
import { autoinject } from "aurelia-dependency-injection";
import { backboneModelProperties } from "../../decorators/backbone-properties";
import { AuthorizationModel } from "../../authentication/models/authorization-model";

@autoinject
@backboneModelProperties({
    urlRoot: AppSettings.SearchApiUrlPrefix + "browse",
    relations: [{
        type: Backbone.Many,
        key: "ListItems",
        relatedModel: Backbone.AssociatedModel
    },
    {
        type: Backbone.Many,
        key: "PreRequisites",
        relatedModel: BrowsePanelModel
    }
    ],
    defaults: {
        ListItems: [],
        PreRequisites: [],
        Loading: true
    }
})
export class BrowsePanelModel extends Backbone.AssociatedModel {

    public static PanelTypes = ["category", "court", "year", "jurisdiction", "material"];

    @prop() public DefaultType: string;
    @prop() public SelectedType: string;
    @prop() public Loading: boolean;
    @prop() public ListItems: Backbone.Collection<Backbone.AssociatedModel>;
    @prop() public PreRequisites: Backbone.Collection<BrowsePanelModel>;
    @prop() public Value: number;

    constructor(options?) {
        super(options);
    }

    public load(): Promise<any> {
        const url = `${AppSettings.GraphApiUrlPrefix}browse/${this.SelectedType}?fullTextOnly=false&subscriptionOnly=false`;
        const prs: any[] = [];
        this.PreRequisites.each((pr) => {
            const item = {
                Type: pr.SelectedType,
                Value : pr.Value
            };
            prs.push(item);
        });
        const data: any = {};
        data.preRequisites = prs;
        const request = $.ajax({
            type: "POST",
            url: url,
            data: data,
            dataType: "json",
            beforeSend: AuthorizationModel.attachAuthorizationHeader
        });
        return Promise.resolve(request)
            .then((response) => {
                this.ListItems.reset();
                this.ListItems.add(response.Items);
                this.Loading = false;
            }).catch((ex) => {
                this.Loading = false;
            });
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/old-browse/models/browse-panel.ts